import * as THREE from 'three'
import Experience from './Experience.js'

export default class Raycaster
{
    constructor()
    {
        this.experienceRef = new Experience()
        this.debugRef = this.experienceRef.debug
        this.sceneRef = this.experienceRef.threeJSscene
        this.resourcesRef = this.experienceRef.resources
        this.cameraRef = this.experienceRef.camera
        this.sizesRef = this.experienceRef.sizes
        this.performanceRef = this.experienceRef.performance
        this.postProcessingRef = this.experienceRef.postProcessing;
        this.cameraRef = this.experienceRef.camera;
        this.workDenSceneRef = this.experienceRef.world.workDenScene;            
        this.setupRaycasting();
        this.mouseHoverEnabled = false;
        
    }   

    setupRaycasting()
    {
        // Setup
        this.raycaster = new THREE.Raycaster();
        this.cursorDown = new THREE.Vector2();
        this.cursor = new THREE.Vector2();            
        this.controllerRef = this.experienceRef.controller;
        
        if (this.workDenSceneRef.catRigAndModel.scene)
        {
            this.workDenSceneRef.catMimi.updateMatrixWorld(true);
            this.workDenSceneRef.catCindy.updateMatrixWorld(true);
        }
        

        // Touch listener
        this.touchedPoints = [];
        window.addEventListener('mousemove', (event) => 
        {                
            // Convert values to -1 to +1 range
            this.cursor.x = (event.clientX / this.sizesRef.width) * 2 - 1;
            this.cursor.y = -((event.clientY / this.sizesRef.height) * 2 - 1);

            // this.absX = Math.abs(this.cursor.x)
            // this.absY = Math.abs(this.cursor.y)

            this.onObjectHover(this.cursor);
        });
        
        // Click listener - Part A
        window.addEventListener('pointerdown', (event) =>
        {
            this.touchedPoints.push(event.pointerId)

            this.cursorXMin = Math.abs((event.clientX / this.sizesRef.width * 2 - 1)*0.9)
            this.cursorXMax = Math.abs((event.clientX / this.sizesRef.width * 2 - 1)*1.1)

            this.cursorYMin = Math.abs((event.clientY / this.sizesRef.height * 2 - 1)*0.9)
            this.cursorYMax = Math.abs((event.clientY / this.sizesRef.height * 2 - 1)*1.1)

        });

        // Click listener - Part B
        window.addEventListener('pointerup', (event) =>
        {
            // Convert values to -1 to +1 range
            this.cursor.x = (event.clientX / this.sizesRef.width) * 2 - 1;
            this.cursor.y = -((event.clientY / this.sizesRef.height) * 2 - 1);

            this.absX = Math.abs(this.cursor.x)
            this.absY = Math.abs(this.cursor.y)

            if(this.touchedPoints.length === 1 && 
            this.absX > this.cursorXMin && this.absX < this.cursorXMax &&
            this.absY > this.cursorYMin && this.absY < this.cursorYMax)
            {
                this.click(this.cursor)
                this.touchedPoints = []
            }
            else
            {   
                this.touchedPoints = []
            }
        });
    }

    onObjectHover(cursor)
    {
        if (!this.cameraRef.isCameraTweening && this.mouseHoverEnabled)
        {
                // Mouse events interacted objects container for Outline Pass
            this.selectedObjects = []; 
            this.raycaster.setFromCamera(cursor, this.cameraRef.cameraInstance);       

            //Object click listener
            this.intersectsObjects = this.raycaster.intersectObjects(this.workDenSceneRef.interactableObjects);

            if(this.intersectsObjects.length)
            {
                //console.log(this.intersectsObjects)
                this.selectedModel = this.intersectsObjects[0].object;            

                if (this.cameraRef.cameraState == 'default')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.behanceLogo.children[0]:
                            //console.log("Behance Logo");
                            this.selectedObjects.push(this.workDenSceneRef.behanceLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.behanceLogo.children[1]:
                            //console.log("Behance Logo");
                            this.selectedObjects.push(this.workDenSceneRef.behanceLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;    
                        case this.workDenSceneRef.linkedInLogo.children[0]:
                            //console.log("LinkedIn Logo");
                            this.selectedObjects.push(this.workDenSceneRef.linkedInLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.linkedInLogo.children[1]:
                            //console.log("LinkedIn Logo");
                            this.selectedObjects.push(this.workDenSceneRef.linkedInLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;               
                        case this.workDenSceneRef.githubLogo:
                            //console.log("Github Logo");
                            this.selectedObjects.push(this.workDenSceneRef.githubLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.threeJsLogo:
                            //console.log("ThreeJS Logo");
                            this.selectedObjects.push(this.workDenSceneRef.threeJsLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.resume:
                            //console.log("Resume");
                            this.selectedObjects.push(this.workDenSceneRef.resume);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            break;
                        case this.workDenSceneRef.resumeAbridged:
                            //console.log("Abridged Resume");
                            this.selectedObjects.push(this.workDenSceneRef.resumeAbridged);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;                 
                            break;
                        case this.workDenSceneRef.monitorScreen:
                            //console.log("Desktop PC Monitor");
                            this.selectedObjects.push(this.workDenSceneRef.monitorScreen);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;                  
                            break;
                        case this.workDenSceneRef.draftingTableSketch:
                            //console.log("Drafting Table Sketch");
                            this.selectedObjects.push(this.workDenSceneRef.draftingTableSketch);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[0]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[1]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;                        
                        case this.workDenSceneRef.desktopPcCabinet.children[1]:
                            //console.log("Desktop PC Cabinet");
                            this.selectedObjects.push(this.workDenSceneRef.desktopPcCabinet);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            break;
                        case this.workDenSceneRef.macbookScreen:
                            //console.log("Macbook Screen");
                            this.selectedObjects.push(this.workDenSceneRef.macbookScreen);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            //this.postProcessingRef.outlinePass.edgeThickness = 10;                    
                            this.postProcessingRef.outlinePass.enabled = true;
                            break;
                        case this.workDenSceneRef.catMimiBodyMesh:
                            //console.log("Cat - Mimi");                            
                            this.selectedObjects.push(this.workDenSceneRef.catMimi);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            //this.postProcessingRef.outlinePass.edgeThickness = 10;                    
                            this.postProcessingRef.outlinePass.enabled = true;
                            break;
                        case this.workDenSceneRef.catCindyBodyMesh:
                            //console.log("Cat - Cindy");                            
                            this.selectedObjects.push(this.workDenSceneRef.catCindy);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            //this.postProcessingRef.outlinePass.edgeThickness = 10;                    
                            this.postProcessingRef.outlinePass.enabled = true;
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[0]:
                            //console.log("Cricket Equipment");
                            this.selectedObjects.push(this.workDenSceneRef.cricketEquipment);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                         case this.workDenSceneRef.cricketEquipment.children[1]:
                            //console.log("Cricket Equipment");
                            this.selectedObjects.push(this.workDenSceneRef.cricketEquipment);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[2]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[3]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[4]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                    }
                }

                if (this.cameraRef.cameraState == 'resumeAbridgedFocussed' || this.cameraRef.cameraState == 'resumeLongFocussed')
                {
                    this.postProcessingRef.outlinePass.enabled = false;
                    // Clear the array if no objects to highlight
                    this.selectedObjects.length = 0;
                    return;
                }

                if (this.cameraRef.cameraState == 'draftingTableFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.draftingTableSketch:
                            //console.log("Drafting Table Sketch");
                            this.selectedObjects.push(this.workDenSceneRef.draftingTableSketch);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                    }                    
                }

                if (this.cameraRef.cameraState == 'documentFolderFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.documentFolder.children[0]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                        case this.workDenSceneRef.documentFolder.children[1]:
                            //console.log("Document Folder");
                            this.selectedObjects.push(this.workDenSceneRef.documentFolder);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;           
                            break;
                    }                    
                }

                if (this.cameraRef.cameraState == 'logoFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.behanceLogo.children[0]:
                            //console.log("Behance Logo");
                            this.selectedObjects.push(this.workDenSceneRef.behanceLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.behanceLogo.children[1]:
                            //console.log("Behance Logo");
                            this.selectedObjects.push(this.workDenSceneRef.behanceLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;    
                        case this.workDenSceneRef.linkedInLogo.children[0]:
                            //console.log("LinkedIn Logo");
                            this.selectedObjects.push(this.workDenSceneRef.linkedInLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                        case this.workDenSceneRef.linkedInLogo.children[1]:
                            //console.log("LinkedIn Logo");
                            this.selectedObjects.push(this.workDenSceneRef.linkedInLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;               
                        case this.workDenSceneRef.githubLogo:
                            //console.log("Github Logo");
                            this.selectedObjects.push(this.workDenSceneRef.githubLogo);
                            this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                            this.postProcessingRef.outlinePass.enabled = true;
                            this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                            this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                            break;
                    }
                }

                if (this.cameraRef.cameraState == 'threeJSLogoFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.threeJsLogo:
                        //console.log("ThreeJS Logo");
                        this.selectedObjects.push(this.workDenSceneRef.threeJsLogo);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FF0000');
                        this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FF0000');
                        break;
                    }
                }

                if (this.cameraRef.cameraState != 'default')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.backNote1:
                        //console.log("Back note1");
                        this.selectedObjects.push(this.workDenSceneRef.backNote1);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote2:
                        //console.log("Back note2");
                        this.selectedObjects.push(this.workDenSceneRef.backNote2);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote3:
                        //console.log("Back note3");
                        this.selectedObjects.push(this.workDenSceneRef.backNote3);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.monitorONOFFbutton:
                        //console.log("Back note4");
                        this.selectedObjects.push(this.workDenSceneRef.backNote4);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote4:
                        //console.log("Back note4");
                        this.selectedObjects.push(this.workDenSceneRef.backNote4);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote5:
                        //console.log("Back note5");
                        this.selectedObjects.push(this.workDenSceneRef.backNote5);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote6:
                        //console.log("Back note6");
                        this.selectedObjects.push(this.workDenSceneRef.backNote6);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;   
                    case this.workDenSceneRef.backNote7:
                        //console.log("Back note7");
                        this.selectedObjects.push(this.workDenSceneRef.backNote7);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote8:
                        //console.log("Back note8");
                        this.selectedObjects.push(this.workDenSceneRef.backNote8);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote9:
                        //console.log("Back note9");
                        this.selectedObjects.push(this.workDenSceneRef.backNote9);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    case this.workDenSceneRef.backNote10:
                        //console.log("Back note10");
                        this.selectedObjects.push(this.workDenSceneRef.backNote10);
                        this.postProcessingRef.outlinePass.selectedObjects = this.selectedObjects;
                        this.postProcessingRef.outlinePass.enabled = true;
                        break;
                    }
                }
            }
            else
            {
                this.postProcessingRef.outlinePass.enabled = false;
                this.postProcessingRef.outlinePass.edgeThickness = 4;
                this.postProcessingRef.outlinePass.edgeStrength = 10;
                this.postProcessingRef.outlinePass.visibleEdgeColor.set('#FFFFFF');
                this.postProcessingRef.outlinePass.hiddenEdgeColor.set('#FFFFFF');
                // Clear the array if no objects to highlight
                this.selectedObjects.length = 0;
            }
        }  
    }

    click(cursor)
    {        
        if (!this.cameraRef.isCameraTweening)
        {
            this.raycaster.setFromCamera(cursor, this.cameraRef.cameraInstance)        

            //Object click listener
            this.intersectsObjects = this.raycaster.intersectObjects(this.workDenSceneRef.interactableObjects);
            if(this.intersectsObjects.length)
            {
                //console.log(this.intersectsObjects)
                this.selectedModel = this.intersectsObjects[0].object            

                if (this.cameraRef.cameraState == 'default')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.behanceLogo.children[0]:
                            //console.log("Behance Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('behance');
                            break;
                        case this.workDenSceneRef.behanceLogo.children[1]:
                            //console.log("Behance Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('behance');
                            break;    
                        case this.workDenSceneRef.linkedInLogo.children[0]:
                            //console.log("LinkedIn Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('linkedIn');
                            break;
                        case this.workDenSceneRef.linkedInLogo.children[1]:
                            //console.log("LinkedIn Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('linkedIn');
                            break;               
                        case this.workDenSceneRef.githubLogo:
                            //console.log("Github Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('github');
                            break;
                        case this.workDenSceneRef.resume:
                            //console.log("Resume clicked");
                            this.controllerRef.interactiveControls.resumeGroupClicked('resumeLong');
                            break;
                        case this.workDenSceneRef.resumeAbridged:
                            //console.log("Abridged Resume clicked");                    
                            this.controllerRef.interactiveControls.resumeGroupClicked('resumeAbridged');                        
                            break;                    
                        case this.workDenSceneRef.threeJsLogo:
                            //console.log("Three JS logo clicked");                    
                            this.controllerRef.interactiveControls.threeJSlogoClicked();
                            break;
                        case this.workDenSceneRef.monitorScreen:
                            //console.log("Desktop Monitor clicked");
                            this.controllerRef.interactiveControls.desktopMonitorClicked();
                            break;
                        case this.workDenSceneRef.draftingTableSketch:
                            //console.log("Drafting Table Sketch clicked");
                            this.controllerRef.interactiveControls.draftingTableSketchClicked();
                            break;
                        case this.workDenSceneRef.documentFolder.children[0]:
                            //console.log("Document Folder clicked");
                            this.controllerRef.interactiveControls.documentFolderClicked();
                            break;
                        case this.workDenSceneRef.documentFolder.children[1]:
                            //console.log("Document Folder clicked");
                            this.controllerRef.interactiveControls.documentFolderClicked();
                            break;
                        case this.workDenSceneRef.monitorONOFFbutton:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;                           
                        case this.workDenSceneRef.desktopPcCabinet.children[1]:
                            //console.log("Desktop PC Cabinet clicked");
                            this.controllerRef.interactiveControls.desktopPcCabinetClicked();
                            break;
                        case this.workDenSceneRef.macbookScreen:
                            //console.log("Macbook clicked");
                            this.controllerRef.interactiveControls.macbookScreenClicked();
                            break;
                        case this.workDenSceneRef.catMimiBodyMesh:
                            //console.log("Cat Mimi clicked");
                            this.controllerRef.interactiveControls.catMimiClicked();
                            break;
                        case this.workDenSceneRef.catCindyBodyMesh:
                            //console.log("Cat Cindy clicked");
                            this.controllerRef.interactiveControls.catCindyClicked();
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[0]:
                            //console.log("Cricket Equipment clicked");
                            this.controllerRef.interactiveControls.cricketEquipmentClicked();
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[1]:
                            //console.log("Cricket Equipment clicked");
                            this.controllerRef.interactiveControls.cricketEquipmentClicked();
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[2]:
                            //console.log("Cricket Equipment clicked");
                            this.controllerRef.interactiveControls.cricketEquipmentClicked();
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[3]:
                            //console.log("Cricket Equipment clicked");
                            this.controllerRef.interactiveControls.cricketEquipmentClicked();
                            break;
                        case this.workDenSceneRef.cricketEquipment.children[4]:
                            //console.log("Cricket Equipment clicked");
                            this.controllerRef.interactiveControls.cricketEquipmentClicked();
                            break;
                    }
                }

                if (this.cameraRef.cameraState == 'resumeAbridgedFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.resumeAbridgedOpenButton:
                            //console.log("Abridged Resume Open external link clicked");
                            this.controllerRef.interactiveControls.resumeGroupClicked('openResumeAbridged');
                            break;
                        case this.workDenSceneRef.resumeAbridgedCloseButton:
                            //console.log("Abridged Resume Close close-up view clicked");
                            this.controllerRef.interactiveControls.resumeGroupClicked('closeResumeAbridged');
                            break;
                    }
                    
                    return;
                }
                
                if (this.cameraRef.cameraState == 'resumeLongFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.resumeLongOpenButton:
                            //console.log("Long Resume Open external link clicked");
                            this.controllerRef.interactiveControls.resumeGroupClicked('openResumeLong');
                            break;
                        case this.workDenSceneRef.resumeLongCloseButton:
                            //console.log("Long Resume Close close-up view clicked");
                            this.controllerRef.interactiveControls.resumeGroupClicked('closeResumeLong');
                            break;
                    }

                    return;
                }
                
                if (this.cameraRef.cameraState == 'draftingTableFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.draftingTableSketch:
                            //console.log("Drafting Table Sketch clicked");
                            this.controllerRef.interactiveControls.draftingTableSketchClicked();
                            break;
                    }          
                }

                if (this.cameraRef.cameraState == 'documentFolderFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.documentFolder.children[0]:
                            //console.log("Document Folder clicked");
                            this.controllerRef.interactiveControls.documentFolderClicked();
                            break;
                        case this.workDenSceneRef.documentFolder.children[1]:
                            //console.log("Document Folder clicked");
                            this.controllerRef.interactiveControls.documentFolderClicked();
                            break;
                    }          
                }

                if (this.cameraRef.cameraState == 'logoFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.behanceLogo.children[0]:
                            //console.log("Behance Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('behance');
                            break;
                        case this.workDenSceneRef.behanceLogo.children[1]:
                            //console.log("Behance Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('behance');
                            break;    
                        case this.workDenSceneRef.linkedInLogo.children[0]:
                            //console.log("LinkedIn Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('linkedIn');
                            break;
                        case this.workDenSceneRef.linkedInLogo.children[1]:
                            //console.log("LinkedIn Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('linkedIn');
                            break;               
                        case this.workDenSceneRef.githubLogo:
                            //console.log("Github Logo clicked");
                            this.controllerRef.interactiveControls.logoClusterClicked('github');
                            break;
                    }
                }

                if (this.cameraRef.cameraState == 'threeJSLogoFocussed')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.threeJsLogo:
                            //console.log("Three JS logo clicked");                    
                            this.controllerRef.interactiveControls.threeJSlogoClicked();
                            break;
                    }
                }
                
                if (this.cameraRef.cameraState != 'default')
                {
                    switch(this.selectedModel)
                    {
                        case this.workDenSceneRef.backNote1:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote2:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote3:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote4:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote5:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote6:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote7:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote8:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote9:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                        case this.workDenSceneRef.backNote10:
                            //console.log("Back Sticky Note clicked");
                            this.controllerRef.interactiveControls.backStickyNoteClicked();
                            break;
                    }
                }
            }
        }

        
    }

    togglePPoutline = async (duration) =>
    {
        this.postProcessingRef.outlinePass.enabled = false;
        await this.sleep(2000);
        this.postProcessingRef.outlinePass.enabled = true;
    }

    sleep(ms) 
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}